import { Redirect } from "react-router-dom";
import useParams from "../utilities/useParams";
import "./EventNameWrapper.css";
import { useQuery } from "react-query";
import { getEvents } from "../api";
import Loading from "./Loading";

const EventNameWrapper = ({ children, showTitle = true }) => {
  const params = useParams();
  const eventId = params.get("event");
  const { data: eventsData, isLoading } = useQuery("events", getEvents);
  const hasSelectedEvent = !!eventId && eventId !== "null";

  const selected = eventsData?.data.find((event) => event.id == eventId);

  if (hasSelectedEvent && isLoading) {
    return <Loading />;
  }

  if (hasSelectedEvent && eventsData?.data && !selected) {
    return <Redirect to="/not-found" />;
  }

  return (
    <>
      {showTitle && selected && (
        <div className="app-padding margin-24 margin-bottom">
          <h2 id="event-title">{selected.title}</h2>
        </div>
      )}
      {children}
    </>
  );
};
export default EventNameWrapper;
